import React from "react";


const Tabs = ({children}) => {
    return <div className="tabs">{children}</div>;
};

const Tab = ({ id, label, children }) => {
    return (
      <div className="tab">
        <input type="checkbox" id={id} />
        <label className="tab-label" htmlFor={id}>{label}</label>
        <div className="tab-content">{children}</div>
      </div>
    );
  };

// Named exports for both Tab and Tabs
export { Tab, Tabs };